import { Component, instantiate, Node, Prefab, ScrollView, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import MachineRecord from './MachineRecord/MachineRecord';
import JackpotMachineRecord from './MachineRecord/JackpotMachineRecord';
import ItemGenerator from '../../../../../common/scripts/Toolkit/Components/Misc/ItemGenerator';
import LobbyHistoryModel from '../../../Data/Model/LobbyHistoryModel';
import BaseMachineRecord from './MachineRecord/BaseMachineRecord';
import HistoryData from '../../../Data/DataObject/History/HistoryData';
import PreviewHistoryData from '../../../Data/DataObject/History/PreviewHistoryData';

const { ccclass, property } = _decorator;

@ccclass('MachineRecordList')
export default class MachineRecordList extends Component {
    @property(ScrollView)
    private readonly scrollView: ScrollView = null;

    @property(Node)
    private readonly bottomIndicator: Node = null;

    @property(Prefab)
    private readonly jackpotRecordPrefab: Prefab = null;

    private _machineRecordGenerator: ItemGenerator = null;
    private _jackpotMachineRecord: JackpotMachineRecord = null;
    private _noRecordHint: Node = null;
    private _loadingMark: Node = null;

    private get machineRecordGenerator() {
        if (!this._machineRecordGenerator) {
            this._machineRecordGenerator = this.scrollView.content.getComponentInChildren(ItemGenerator);
        }
        return this._machineRecordGenerator;
    }

    private get jackpotMachineRecord() {
        if (!this._jackpotMachineRecord) {
            const node = instantiate(this.jackpotRecordPrefab);
            this._onMachineRecordInstantiated(node);
            // to make sure the jackpot record is first child
            node.zIndex = -1;
            this._jackpotMachineRecord = node.getComponent(JackpotMachineRecord);
        }
        return this._jackpotMachineRecord;
    }

    public onLoad() {
        this.machineRecordGenerator.on(ItemGenerator.EVENT_TYPE.ITEM_GENERATED, this._onMachineRecordInstantiated, this);
    }

    public onEnable() {
        Lobby.history.on(LobbyHistoryModel.EVENT_TYPE.TIME_RANGE_CHANGED, this._onRecordDataChanged, this);
        Lobby.history.on(LobbyHistoryModel.EVENT_TYPE.GAME_TYPE_CHANGED, this._onRecordDataChanged, this);
        Lobby.history.on(LobbyHistoryModel.EVENT_TYPE.IS_REQUESTING_DATA_LIST_STATE_CHANGED, this._updateLoadingMarkVisibility, this);
        this._updateContent();
        this._updateLoadingMarkVisibility();
        this._scrollToTop();
    }

    public onDisable() {
        Lobby.history.off(LobbyHistoryModel.EVENT_TYPE.TIME_RANGE_CHANGED, this._onRecordDataChanged, this);
        Lobby.history.off(LobbyHistoryModel.EVENT_TYPE.GAME_TYPE_CHANGED, this._onRecordDataChanged, this);
        Lobby.history.off(LobbyHistoryModel.EVENT_TYPE.IS_REQUESTING_DATA_LIST_STATE_CHANGED, this._updateLoadingMarkVisibility, this);
    }

    public init(noRecordHint: Node, loadingMark: Node) {
        this._noRecordHint = noRecordHint;
        this._loadingMark = loadingMark;
    }

    private _scrollToTop() {
        this.scrollView.stopAutoScroll();
        this.scrollView.scrollToTop();
    }

    private _onRecordDataChanged() {
        this._updateContent();
        this._scrollToTop();
    }

    private async _updateContent() {
        await Lobby.history.syncDataList();
        // TODO: SinglePlay 有分桌，MultiPlay 需要合併?
        const tempMap: { [key: string]: HistoryData[] } = {};
        Lobby.history.dataList.forEach((data: HistoryData) => {
            const key = `${data.gameID}_${data.machineID}`;
            if (!tempMap[key]) {
                tempMap[key] = [];
            }
            tempMap[key].push(data);
        });
        const reportData = Object.values(tempMap).map((dataList) => new PreviewHistoryData(dataList[0].gameID, dataList[0].machineID, dataList));
        const reports = [...reportData];
        // const deviceReports = !FeatureGame.config.txGameID ? reports : reports.filter((report) => report.gameID === FeatureGame.config.txGameID);
        // const jackpotReport = reportData.jackpotReport.count ? reportData.jackpotReport : null;
        const isEmpty = !reports.length;
        this.bottomIndicator.opacity = isEmpty ? 0 : 255;
        this._noRecordHint.active = isEmpty;

        // jackpot
        if (Lobby.jackpot.isJackpotApplied) {
            // if (jackpotReport) {
            //     this.jackpotMachineRecord.node.setParent(this.machineRecordGenerator.node.parent);
            //     this.jackpotMachineRecord.display(jackpotReport);
            // } else
            if (this._jackpotMachineRecord) {
                this._jackpotMachineRecord.node.setParent(null);
            }
        }

        // machines
        if (reports.length) {
            this.machineRecordGenerator.displayItemCount = reports.length;
            // sort by last played time, the latest played machine will be displayed at the top
            reports
                .sort((a, b) => b.timestamp - a.timestamp)
                .forEach((deviceReport, index) => {
                    const machineRecord = this.machineRecordGenerator.items[index].getComponent('BaseMachineRecord') as BaseMachineRecord;
                    machineRecord.display(deviceReport);
                });
        } else {
            this.machineRecordGenerator.displayItemCount = 0;
        }
    }

    private _updateLoadingMarkVisibility() {
        this._loadingMark.active = Lobby.history.isRequestingDataList;
    }

    private _onMachineRecordInstantiated(item: Node) {
        item.on(MachineRecord.EVENT_TYPE.ENTER_MACHINE, (machineID: string) => this.emit(MachineRecord.EVENT_TYPE.ENTER_MACHINE, machineID));
        item.on(MachineRecord.EVENT_TYPE.OPEN_MACHINE_RECORD_LIST, (...args: any[]) => this.emit(MachineRecord.EVENT_TYPE.OPEN_MACHINE_RECORD_LIST, ...args));
    }
}
